<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Anthony C. Mazzella was born many years ago but can’t specifically remember the incident. New York City was his home but the South Bronx in the ’60s was his playground. It was a simple life of sewer-to-sewer stick ball and summers spent in the “country”. As Anthony got older, he learned that there is good and bad, God and Satan, and a constant back and forth between them, all existing in the hearts and minds of people. He hopes you learn this too.</p><br/>
<p style="text-align: center;"><img alt="" src="media/file0.jpg" style="width:2.76702in;height:2.6875in;  filter: grayscale(100%);
"/></p><br/>
<p style="text-align: center;">Photo credit: Genevieve of The Parlour in Keyport, NJ (World’s Spookiest Place)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?92edcc44